module.exports = __webpack_public_path__ + "images/ExternalPromo/fiverr-gaming-728_90.jpg?51ea5";